export default __webpack_public_path__ + "static/qlik-testimonial-ma-ec0065815a1bccdd0562be8215823020.png";